<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  methods: {
    fontSizeMatchDeviceWidth () {
      console.log('fontSizeMatchDeviceWidth')
      var deviceWidth =
          document.documentElement.clientWidth || window.screen.width || 320
      var devicePixelRatio = window.devicePixelRatio || 1
      var fontSize = Math.ceil((deviceWidth * 16) / 320)
      window.clientHeight =
          document.body.clientHeight || window.screen.height
      window.rootFontSize = fontSize
      var scale = 1 / devicePixelRatio // 默认的缩放
      console.log(fontSize, scale, devicePixelRatio)
      document.documentElement.style.fontSize = fontSize + 'px'
      document
        .querySelector('meta[name="viewport"]')
        .setAttribute(
          'content',
          'width=device-width,initial-scale=' +
              scale +
              ',maximum-scale=' +
              scale +
              ',minimum-scale=' +
              scale +
              ',user-scalable=no,viewport-fit=cover'
        ) // 增加viewport-fit=cover适配iphone x
    },
    autoRootFontSize () {
      const that = this
      var ua = navigator.userAgent
      if (
        /android/i.test(ua) ||
          /ipad|itouch|iphone/i.test(ua) ||
          /tianqi/i.test(ua)
      ) {
        console.log('mobile autoRootFontSize')
        this.fontSizeMatchDeviceWidth.apply(that)
      } else {
        // pc端优雅降级
        console.log('pc autoRootFontSize')
        document.documentElement.style.fontSize = '24px'
      }
    }
  },
  mounted () {
    const that = this
    window.addEventListener('resize', this.autoRootFontSize.bind(that))
    this.autoRootFontSize()
    setTimeout(this.autoRootFontSize.bind(that), 50)
  }
}
</script>
<style src='../assets/css/index.less' lang='less'></style>

<style lang="less">
</style>
